import React from "react";
import "./css/Organization.css";
import { Box, Card, CardContent, Stack, Typography} from "@mui/material";
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
export const NumberCard = ({title, subtitle, suffix, subtitleStyle, endValue, prefix, decimals, width}) => {
  const { ref, inView } = useInView({
    triggerOnce: true, // Trigger animation only once
    threshold: 0.5,    // Animation triggers when 50% of the component is visible
  });
return <Card ref={ref} variant="elevation" sx={{ minWidth: {lg: 397, xs: "fit-content"},maxWidth: {lg: 357, xs: "fit-content"},  paddingTop: "10px", border: "none", minHeight: {lg: 214, xs: 'fit-content'}, maxHeight: {lg: 600, xs: 'fit-content'}, boxShadow: "none", background: "transparent", display: "flex", flexDirection: "column", alignItems: "center" }}>
 <Typography gutterBottom variant="h5" component="div" sx={{
    fontFamily: 'Poppins',
    fontWeight: 700,
    fontSize: {lg: '80px', xs: "48px"},
    lineHeight: {
      xs: '120%',
      sm: '120%',
      md: '120%',
      lg: '120%',
    },
    color: "#fff",
    margin: 0,
  }}>
      {inView && (
          <CountUp style={{fontWeight: "600"}} className="count-text" prefix={prefix} start={0} end={endValue || 86} duration={2.5} suffix={suffix || ""} decimals={decimals || 0} />
        )}
  </Typography>
<CardContent sx={{ position: "relative", zIndex: 1, background: "transparent", padding: 0, paddingTop: '24px' }}>
  <Typography gutterBottom variant="h5" component="div" sx={{
    color: "#fff",
    fontFamily: 'Poppins',
    textAlign: "center",
    fontWeight: 600,
    width: {xs: "100%"},
    minHeight: {md: "80px", xs: "fit-content"},
    marginBottom: "12px",
    marginLeft: "auto",
    marginRight: "auto",
    fontSize: {
      xs: '20px',
      sm: '20px',
      md: '20px',
      lg: '20px',
    },
    lineHeight: {
      xs: '120%',
      sm: '120%',
      md: '120%',
      lg: '120%',
    },
  }}>
    {title || "of data breaches involve compromised identities"}
  </Typography>
  <Typography variant="body2" color="text.secondary" sx={{
    color: "#fff",
    fontFamily: 'Poppins',
    fontWeight: 400,
    width: "70%",
    marginLeft: "auto",
    marginRight: "auto",
    textAlign: "center",
    fontSize: {
      xs: '16px',
      sm: '16px',
      md: '16px',
      lg: '16px',
    },
    lineHeight: {
      xs: '25px',
      sm: '24px',
      md: '24px',
      lg: '24px',
    },
    ...subtitleStyle
  }}>
    {subtitle || "Verizon DBIR 2023"}
  </Typography>
</CardContent>
</Card>
}

function Organizations() {

  return (
    <Box sx={{overflowX: "hidden"}}
      className="texture-background"
    >
        <Box display={"flex"} flexDirection="column" justifyContent={"center"}>
          <Typography
            variant="h2"
            sx={{
              m: {
                sm: "80px 0px 80px 0px",
                xs: "64px 16px 48px 16px",

              },
              font: {
                lg: "normal normal 600 48px/120% Poppins",
                md: "normal normal 600 48px/120% Poppins",
                sm: "normal normal 600 48px/120% Poppins",
                xs: "normal normal 600 20px/120% Poppins",
              },
              color: "#FFFFFF",
              textAlign: "center"
            }}
          >
         Zero Trust Security is the Need of the Hour
          </Typography>
            <Stack flexDirection={{lg:'row', xs: "column"}} alignItems={'center'} justifyContent={'center'} width={'100%'} marginBottom={"48px"}>
            <Box style={{paddingLeft: "0px", paddingRight: '16px'}}>
                <NumberCard title={'Time it takes to identify and contain a data breach'} subtitle={'IBM Cost of a Data Breach Report 2024'} endValue={292} suffix={" Days"} />
            </Box>
            <Box style={{paddingLeft: '16px', paddingRight: '16px'}} className="blur-border">
                <NumberCard subtitleStyle={{width: "80%"}} endValue={76} suffix={"%"} title={'Cyberattacks involve the human element'} subtitle={"Verizon's 2024 Data Breaches Investigations Report"} />
            </Box>
            <Box sx={{paddingLeft: {lg:'16px', xs: 0}, paddingRight: {xs: "0px", lg: "0px"}}}>
              <NumberCard  subtitleStyle={{width: "50%"}} suffix={' M'} endValue={30} title={'Cyberattacks happen daily on enterprises globally'} subtitle={'SonicWall Cyber Threat 2024'} />
            </Box>
            </Stack>
        </Box>
    </Box>
  );
}

export default Organizations;
